export const buttonAnalyticsMeta = {
  componentName: 'banner',
  title: 'primaryButton',
};
